import { BlogPostType } from "../types/BlogPostType";
import { ApiResult } from "../types/nlsApiTypes";
import axios from "axios";

import { createNewBlogPost, testCreateNewBlogPost } from "../apiConsts";

export async function createBlogPostEntry(
  blogPost: string
): Promise<ApiResult> {
  try {
    const response = await axios.post(createNewBlogPost, {
      blogEntry: blogPost,
    });
    let result: ApiResult = {
      data: response.data,
      success: response.status == 200,
      status: response.status,
    };
    return result;
    //return response.status === 200;
  } catch (error) {
    let result: ApiResult = {
      status: 500,
      data: null,
      success: false,
    };
    return result;
  }
}

export async function testCreateBlogPostEntry(
  blogEntryId: string
): Promise<ApiResult> {
  try {
    const response = await axios.post(testCreateNewBlogPost, {
      blogEntryId: blogEntryId,
    });
    let result: ApiResult = {
      data: response.data,
      success: response.status == 200,
      status: response.status,
    };
    return result;
    //return response.status === 200;
  } catch (error) {
    let result: ApiResult = {
      status: 500,
      data: null,
      success: false,
    };
    return result;
  }
}
